import React, { useContext, useState } from 'react'
import { Grid, TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Context } from '../../../Store'
import { ErrorMessage } from './ErrorMessage'

export const HowManyPeople = () => {
  const [state, dispatch] = useContext(Context)
  const [howManyPeople, setHowManyPeople] = useState(state?.how_many_people)
  const { t } = useTranslation()

  const onChangeHowManyPeople = (event) => {
    dispatch({ type: 'SET_HOW_MANY_PEOPLE', payload: parseInt(event.target.value) })
    setHowManyPeople(parseInt(event.target.value))
  }

  if (!state.over_12_months) {
    return null
  }

  return (
    <Grid
      item
      xs={12}
      lg={11}
      style={{
        display: state.over_12_months ? 'flex' : 'none',
        flexDirection: 'column',
      }}
    >
      <TextField
        type="number"
        fullWidth
        variant="outlined"
        label={t('booking.checkIn.people.placeholder')}
        value={howManyPeople}
        onChange={onChangeHowManyPeople}
        inputProps={{ min: 1 }}
        onInput={(e) => {
          const el = e.target
          if (parseInt(el) < 1) el.value = 1
        }}
        error={state?.error?.how_many_people}
      />
      {state?.error?.how_many_people && <ErrorMessage error={state?.error?.how_many_people} />}
    </Grid>
  )
}
